/**
 * Handles slidedown module. Used for view more buttons
 * @module slidedown
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options';

export const PLUGIN_NAME = 'slidedown';
export const DEFAULTS = {
  slidedownButton: '.slidedown__btn',
  slidedownContent: '.slidedown__content',
};
/**
 * Applies any sort of event handlers for the slidedown.
 * @param  {jQuery} $el - link
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
const setEventListeners = ($el, options = {}) => {
  const slidedownButton = $(options.slidedownButton);
  const slidedownContent = $(options.slidedownContent);
  slidedownButton.on('click', function() {
    let toggleText = $(this).data('close-copy');
    $(this).data('close-copy', $(this).text()).children('span').text(toggleText);
    slidedownContent.toggleClass('active')
    // if slidedown button has a class of 'active' then focus on first item revealed in column
    if ( slidedownContent.hasClass('active') ) {
      slidedownContent.children().first().find('a').focus();
    // if not, focus on slidedown button
    } else {
      $(this).focus();
    }
  })
}
/**
 * Initializes slidedown.
 * @param {HTMLElement} el - link
 * @param {Object} options - Options used for wiring up the module
 * @see DEFAULTS
 */
export default function slidedown(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions(DEFAULTS, options, $el);
  setEventListeners($el, opts);
}
registerJQueryPlugin(PLUGIN_NAME, slidedown);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/slidedown.js